import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export default function Format({
  value,
  onChange,
}: {
  value: string;
  onChange: (format: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select format" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Landscape">Landscape (16:9)</SelectItem>
        <SelectItem value="Vertical">Vertical (9:16)</SelectItem>
        <SelectItem value="Video Post">Video Post (4:5)</SelectItem>
        <SelectItem value="Square">Square (1:1)</SelectItem>
      </SelectContent>
    </Select>
  );
}
